import { Element, Text } from 'domains/reporter/RichTextEditor/core';
/**
 * Slate is in a mature beta. There will likely be more breaking
 * changes that happen as it gets to 1.0. This is an abstraction
 * layer between our application code and Slate to guard against
 * breaking changes, add additional helpers, and to augment functionality
 * core to Slate.
 */

import { Range as SlateRange } from 'slate';
import './scrubber';
import type { ComponentPropsWithoutRef, HTMLAttributes } from 'react';
import * as React from 'react';
import { Editable as SlateEditable } from 'slate-react';
export * from 'slate';
export * from 'slate-react';
export * from 'slate-history';

// Override Slate "Range" to include our "highlighted" property.
export interface Range extends SlateRange {
  highlighted?: boolean;
}

// Override the MDN Range type; we will always use Slate's Range type in contexts where we import Range from this file..

export const Range = {
  ...SlateRange,
};

// Slate doesn't add generics to these commonly used types.
/**
 * `RenderElementProps` are passed to the `renderElement` handler.
 */
export type RenderElementProps<T = Element> = {
  children: React.ReactNode;
  element: T;
  attributes: {
    ['data-slate-node']: 'element';
    ['data-slate-inline']?: true;
    ['data-slate-void']?: true;
    dir?: 'rtl';
    ref: React.Ref<HTMLElement | null>;
  };
};

/**
 * `RenderLeafProps` are passed to the `renderLeaf` handler.
 */
export type RenderLeafProps<T = Text> = {
  children: React.ReactNode;
  leaf: T;
  text: Text;
  attributes: {
    ['data-slate-leaf']: true;
  };
};

/**
 * `EditableProps` are passed to the `<Editable>` component.
 */
type SlateEditableProps = ComponentPropsWithoutRef<typeof SlateEditable>;

export type EditableProps = SlateEditableProps &
  HTMLAttributes<HTMLElement> & {
    decorations?: Range[];
  };
